import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const MENU_ITEM_CLASS_NAME = 'MenuItem';

export const MENU_ITEM_CLASS_SLOTS = ['root', 'coloredAvatar', 'icon'] as const;

export type MenuItemClassSlot = (typeof MENU_ITEM_CLASS_SLOTS)[number];

export interface MenuItemClasses {
	root: string;
	active: string;
	coloredAvatar: string;
	icon: string;
	severityError: string;
	severityWarning: string;
}

export type MenuItemClassKey = keyof MenuItemClasses;

export const getMenuItemUtilityClass = (slot: string) =>
	generateUtilityClass(MENU_ITEM_CLASS_NAME, slot);

export const menuItemClasses: MenuItemClasses = generateUtilityClasses(
	MENU_ITEM_CLASS_NAME,
	[
		'root',
		'active',
		'coloredAvatar',
		'icon',
		'severityError',
		'severityWarning',
	],
);

export default menuItemClasses;
